// extracted by mini-css-extract-plugin
export default {"hotList":"index_hotList_Hg5Ic","play_btn":"index_play_btn_U4UpS","title":"index_title_Pjnvt"};